import type { PropsWithChildren } from 'react'
import { composeClasses } from '../../../utils/src/strings'
import { NavbarV2 } from './NavbarV2'

export interface PortalV2LayoutProps {
  className?: string
  classNameContainerChildren?: string
  classNameMain?: string
  classNameNavbar?: string
}

export const PortalV2Layout = ({
  children,
  className,
  classNameContainerChildren,
  classNameMain,
  classNameNavbar
}: PropsWithChildren<PortalV2LayoutProps>) => {
  return (
    <div
      className={composeClasses(
        className,
        'flex flex-row md:bg-[#E8EDF5] w-full'
      )}
      style={{ height: '100dvh' }}
      view-transition-name="layout"
    >
      <NavbarV2 className={classNameNavbar} />
      <main
        className={composeClasses(
          classNameMain,
          'md:p-1 w-full h-full overflow-y-auto  ui-kit-scrollbar max-w-[100dvw] md:max-w-[calc(100vw-48px)]'
        )}
      >
        <div
          className={composeClasses(
            classNameContainerChildren,
            'md:rounded-xl bg-white ui-kit-scrollbar overflow-y-auto w-full h-full'
          )}
        >
          {children}
        </div>
      </main>
    </div>
  )
}

export default PortalV2Layout
